import { RouteToStateAlgolia } from './routeToState';
import type { StateToRouteAlgoliaOptions } from './stateToRoute';

// Props in uistate that have non configurable fixed names
const UISTATE_FIXED_NAMES = ['page', 'query', 'geoSearch'];

function invertObject(obj: Record<string, string>): Record<string, string> {
  return Object.fromEntries(Object.entries(obj).map(([key, value]) => [value, key]));
}

/*
 The function will return all the get params that can be used in the url
 which are useful to build algolia UI State
*/
function getUrlGetParams(obj: Record<string, any>): string[] {
  let keys: string[] = [];

  Object.entries(obj).forEach(([key, value]) => {
    if (UISTATE_FIXED_NAMES.includes(key)) {
      keys.push(value);
    } else {
      keys = keys.concat(Object.keys(value));
    }
  });

  return keys;
}

/*
  Create routeToStateMapping from mappingConfiguration
  keeping UISTATE_FIXED_NAMES keys as it, and inverting key & values for the rest

  {
    page: 'jobPostingsPage',
    refinementList: {
      'jobCategories': 'categories.facetingDisplay',
    },
  }

  becomes

  {
    page: 'jobPostingsPage',
    refinementList: {
      'categories.facetingDisplay': 'jobCategories',
    },
  }
*/
function getRouteToStateMappingFromMappingConfiguration(
  mappingConfiguration: StateToRouteAlgoliaOptions
) {
  const routeToStateMapping: Record<string, string | Record<string, string>> = {};
  Object.entries(mappingConfiguration).forEach(([key, value]) => {
    if (UISTATE_FIXED_NAMES.includes(key as string)) {
      routeToStateMapping[key] = value;
    } else {
      routeToStateMapping[key] = invertObject(value as Record<string, string>);
    }
  });

  return routeToStateMapping;
}

export default function getMappingConfig(mappingConfiguration: StateToRouteAlgoliaOptions) {
  const stateToRouteMapping = { ...mappingConfiguration };
  const routeToStateMapping = getRouteToStateMappingFromMappingConfiguration(mappingConfiguration);

  return {
    stateToRouteMapping,
    routeToStateMapping: routeToStateMapping as RouteToStateAlgolia,
    urlGetArgs: getUrlGetParams(routeToStateMapping),
  };
}
